<template>
  <el-dialog :visible.sync="showmodal" show-close @close="$emit('close-modal')" title="" width="35%">
    <template #title>
      <p class="px-16 text-center text-lg font-semibold">
        Acknowledge Handoff Receipt Request From
      </p>
    </template>
    <div class="px-8 text-left">
      <div class="flex flex-wrap justify-between">
        <div class="w-1/2">
          <p class="modal-title">3PL Terminal</p>
          <p>
            {{
             orgName
            }}
          </p>
        </div>
        <div class="w-1/2 text-left pl-24">
          <p class="modal-title">Name</p>
          <p class="">
            {{
              data.message.origin.sender == null
                ? "N/A"
                : data.message.origin.sender.firstname + " " + data.message.origin.sender.lastname
            }}
          </p>
        </div>
      </div>

      <div class="flex flex-wrap justify-between mt-4">
        <div class="w-1/2">
          <p class="modal-title">Phone Number</p>
          <p>
            {{
              data.message.origin.sender == null ? "N/A" : data.message.origin.sender.mobile_no
            }}
          </p>
        </div>
        <div class="text-left pl-24 w-1/2">
          <p class="modal-title">Address</p>
          <p class="">
            {{
              data.message.location == null
                ? "N/A"
                : data.message.location.address
            }}
          </p>
        </div>
      </div>

      <div class="flex flex-wrap justify-between mt-4">
        <div class="w-1/2">
          <p class="modal-title">State</p>
          <p>
            {{
              data.message.location == null
                ? "N/A"
                : "N/A"
            }}
          </p>
        </div>
        <div class="w-1/2 text-left pl-24">
          <p class="modal-title">Email</p>
          <p class="">
            {{ data.message.origin.sender == null ? "N/A" : data.message.origin.sender.email }}
          </p>
        </div>
      </div>

      <div class="flex flex-wrap justify-between mt-4">
        <div class="w-1/2">
          <p class="modal-title">Delivery Status</p>
          <p class="text-status">{{ data.message.reason }}</p>
        </div>
        <div class="w-1/2 text-left pl-24">
          <p class="modal-title">Receipt code</p>
          <p class="">******</p>
        </div>
      </div>

      <div class="flex justify-center w-100 mt-5">
        <base-button
          @click="acknowledgeHandoff('accept')"
          text="Acknowledge"
          class="mr-5"
          :loading="loading"
        />
        <base-button 
          @click="acknowledgeHandoff('decline')"
          text="Decline"
          :loading="loading2"
        />
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: ["data", "showmodal"],
  data() {
    return {
      loading: false,
      loading2 : false
    };
  },
  computed: {
    orgName(){
      return this.data?.message?.orgReceiver?.companyname || "N/A"
    }
  },
  methods: {
    async acknowledgeHandoff(action) {
      
      action == 'accept' ? this.loading = true : action == 'decline' ? this.loading2 = true : this.loading = true

      try {
        let payloadMS = {
          status: action == 'accept' ? "accepted" : action == 'decline' ? 'declined' : 'accepted',
          isRead: true,
        };

        await this.$_acknowledgeRequestMS(this.data._id, payloadMS);

        this.generateToast(`Handoff ${action == 'accept' ? "accepted" : action == 'decline' ? 'declined' : 'accepted'} accepted successfully`, `${action == 'accept' ? "success" : action == 'decline' ? 'error' : 'success'}`);

        this.loading = false;
        this.loading2 = false;
        action == 'accept' ? this.$emit("acknowledged") : action == 'decline' ? this.$emit("declined") : this.$emit("acknowledged")

      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>
